<div class="container-fluid">
  @if (currentTimeColumn === 'Contribution Finish') {
    <p style="text-align: right; margin: 0px;"><b>{{'Contribute.lblTimeToClose' | translate}}</b></p>
  }
  @if (currentTimeColumn === 'Contribution Start') {
    <p style="text-align: right; margin: 0px;"><b>{{'Contribute.lblTimeToOpen' | translate}}</b></p>
  }
  <p style="text-align: right; margin: 0px;">{{timeToOpenOrClose}}</p>
  <h4>{{contributeMarket.marketCode}} {{'Contribute.header' | translate}}</h4>
  <app-contribution-summary (getContributions)="GetContributions()" (checkOverrideWindow)="CheckOverrideWindow()"></app-contribution-summary>
  @if (contributeMarket.isMarketOpen === true && contributeMarket.isAllowedUser === true && ((hasCurrentContributions === true && service.currentUser.isReadOnly === true) || service.currentUser.isReadOnly === false)) {
    <div [@slider]="contributeMarket.isMarketOpen === true && contributeMarket.isAllowedUser === true && ((hasCurrentContributions === true && service.currentUser.isReadOnly === true) || service.currentUser.isReadOnly === false)? 'show' : null" class="slider">
      <!-- <p>{{'Contribute.shortDescription' | translate}}</p> -->
      <p style="margin: 10px;">{{shortdescription}}</p>
      <p style="margin: 10px;">{{'Contribute.spreadsheetUpload' | translate}}</p>
      <div style="max-width: 1024px;">
        <div class="row m-0">
          <mat-form-field class="col-6">
            <mat-label>{{'Contribute.lblSpreadsheet' | translate}}</mat-label>
            <input matInput type="text" readonly [(ngModel)]="filename" [ngModelOptions]="{standalone: true}" />
            <input [hidden]="true" #spreadsheetInput type="file" (click)="spreadsheetInput.value=null" (change)="spreadsheetInputChange($event)" accept=".xls,.xlsx"/>
            <button matSuffix mat-flat-button (click)="spreadsheetInput.click()">{{'btnSelect' | translate}}</button>
          </mat-form-field>
          <div class="col-6">
            <button mat-raised-button style="float: right;" color="primary" type="button" (click)="OnClickPopulate()">{{'Contribute.btnPopulate' |
            translate}}</button>
          </div>
        </div>
      </div>
      <div id="contributeTable" class="mt-3 mat-elevation-z6">
        <form>
          <table mat-table [dataSource]="dataSourceNew">
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef style="width: 20%;"> {{'Contribute.thName' | translate}}</th>
              <td mat-cell *matCellDef="let element" [style.color]="element.notes.trim() !== '' ? (element.instrumentAccepted ? 'green' : 'red') : ''">{{element.instrumentDescription}}</td>
            </ng-container>
            <ng-container matColumnDef="space">
              <th mat-header-cell *matHeaderCellDef style="width: auto;"> </th>
              <td mat-cell *matCellDef="let element"></td>
            </ng-container>
            <ng-container matColumnDef="assessedRate">
              <th mat-header-cell *matHeaderCellDef style="width: 10%;"> {{'Contribute.thAssessedRate' | translate}}</th>
              <td mat-cell *matCellDef="let element">
                <mat-label class="{{(element.newRate !== element.rate) && (element.newRate) ? 'hasChangedClass' : (element.notes.trim() !== '' ? (element.instrumentAccepted ? 'hasAccepted' : 'hasRejected') : '')}}" > {{element.assessedRate}} </mat-label>
              </td>
            </ng-container>
            <ng-container matColumnDef="assessedVolume">
              <th mat-header-cell *matHeaderCellDef style="width: 10%;"> {{'Contribute.thAssessedVolume' | translate}}</th>
              <td mat-cell *matCellDef="let element">
                <mat-label class="{{(element.newVolume !== element.volume) && (element.newVolume) ? 'hasChangedClass' : (element.notes.trim() !== '' ? (element.instrumentAccepted ? 'hasAccepted' : 'hasRejected') : '')}}" > {{element.assessedVolume}} </mat-label>
              </td>
            </ng-container>
            <ng-container matColumnDef="level">
              <th mat-header-cell *matHeaderCellDef style="width: 10%;"> {{'Contribute.thLevel' | translate}}</th>
              <td mat-cell *matCellDef="let element">{{element.level}}</td>
            </ng-container>
            <ng-container matColumnDef="defaultSpread">
              <th mat-header-cell *matHeaderCellDef style="width: 10%;"> {{'Contribute.thDefaultSpread' | translate}}</th>
              <td mat-cell *matCellDef="let element">{{element.defaultSpread}}</td>
            </ng-container>
            <ng-container matColumnDef="newSpread">
              <th mat-header-cell *matHeaderCellDef style="width: 10%;"> {{'Contribute.thNewSpread' | translate}}</th>
              <td mat-cell *matCellDef="let element">
                <input class="tableInput" matInput type="text" [(ngModel)]="element.spread" [ngModelOptions]="{standalone: true}"
                  required (focusout)="EnablebtnSubmit()" />
                </td>
              </ng-container>
              <!-- <ng-container matColumnDef="currentRate">
              <th mat-header-cell *matHeaderCellDef style="width: 10%;"> {{'Contribute.thCurrentRate' | translate}}</th>
              <td mat-cell *matCellDef="let element"> <mat-label [ngClass]="{'hasChangedClass':(element.newRate !== element.rate) && (element.newRate)}"> {{element.rate}} </mat-label></td>
            </ng-container>
            <ng-container matColumnDef="currentVolume">
              <th mat-header-cell *matHeaderCellDef style="width: 10%;"> {{'Contribute.thCurrentVolume' | translate}}</th>
              <td mat-cell *matCellDef="let element"> <mat-label [ngClass]="{'hasChangedClass': (element.newVolume !== element.volume) && (element.newVolume)}"> {{element.volume}} </mat-label></td>
            </ng-container> -->
            <ng-container matColumnDef="newRate">
              <th mat-header-cell *matHeaderCellDef style="width: 10%;"> {{'Contribute.thNewRate' | translate}}</th>
              <td mat-cell *matCellDef="let element">
                <input class="tableInput" [ngClass]="{'hasErrorClass': (!element.newRate) && hasSubmitted === true}" matInput type="text" [(ngModel)]="element.newRate" [ngModelOptions]="{standalone: true}"
                  required (focusout)="EnablebtnSubmit()" />
                </td>
              </ng-container>
              <ng-container matColumnDef="newVolume">
                <th mat-header-cell *matHeaderCellDef style="width: 10%;"> {{'Contribute.thNewVolume' | translate}}</th>
                <td mat-cell *matCellDef="let element">
                  @if (element.calculationType === 'wav') {
                    <input class="tableInput" [ngClass]="{'hasErrorClass': (!element.newVolume) && hasSubmitted === true}" matInput type="number" min="0" [(ngModel)]="element.newVolume" [ngModelOptions]="{standalone: true}"
                      required (focusout)="EnablebtnSubmit()"/>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="comments">
                <th mat-header-cell *matHeaderCellDef style="width: 30%;"> {{'Contribute.thComments' | translate}}</th>
                <td mat-cell *matCellDef="let element">
                  <input class="tableInput" matInput type="text" [(ngModel)]="element.comments" [ngModelOptions]="{standalone: true}" />
                </td>
              </ng-container>
              <ng-container matColumnDef="loading">
                <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">{{'tblLoading' | translate}}... </th>
              </ng-container>
              <ng-container matColumnDef="noData">
                <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">{{'Contribute.tblNoData' | translate}}...
                </th>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayColumns;"   matTooltip="{{row.notes}}"></tr>
              <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide':dataSourceNew!=null}"></tr>
              <tr mat-footer-row *matFooterRowDef="['noData']"
              [ngClass]="{'hide':dataSourceNew!=null && instrumentLength != 0}"></tr>
            </table>
          </form>
        </div>
        @if (service.currentUser.isReadOnly === false) {
          <div style="margin: 10px;">
            <button style="float: right;" [disabled]="!canEnablebtnSubmit" mat-raised-button color="primary" type="button" (click)="OnSubmitClick()">{{'btnSubmit' |
            translate}}</button>
          </div>
        }
      </div>
    }
    @if (contributeMarket.isMarketOpen === false && contributeMarket.isAllowedUser === true) {
      <div [@slider]="contributeMarket.isMarketOpen === false && contributeMarket.isAllowedUser === true? 'show' : null" class="slider">
        <p>{{'Contribute.notReady' | translate}}</p>
      </div>
    }
    @if (contributeMarket.isAllowedUser === false  && isLoading === false) {
      <div [@slider]="contributeMarket.isAllowedUser === false  && isLoading === false? 'show' : null" class="slider">
        <p>{{'Contribute.notAllowed' | translate}}</p>
      </div>
    }
    @if (contributeMarket.isMarketOpen === true && contributeMarket.isAllowedUser === true && (hasCurrentContributions === false && service.currentUser.isReadOnly === true)) {
      <div [@slider]="contributeMarket.isMarketOpen === true && contributeMarket.isAllowedUser === true && (hasCurrentContributions === false && service.currentUser.isReadOnly === true)? 'show' : null" class="slider">
        <p>{{'Contribute.noContributions' | translate}}</p>
      </div>
    }

    @if (isLoading === true) {
      <div [@slider]="isLoading === true? 'show' : null" class="slider">
        <p>{{'tblLoading' | translate}}...</p>
      </div>
    }
  </div>
